
export const environment = {
  production: false,
  MOJO_URL: 'https://marketsmojo.motilaloswal.com/',
  FRAPI_URL: 'https://marketsmojoapi.motilaloswal.com/',
  MOJO_SITE: 'https://marketsmojo.motilaloswal.com/',
  STOCK_URL: 'https://marketsmojo.motilaloswal.com/stocks-analysis/',
  TRA80_URL: 'https://frapi.trading80.com/',
  MOJO_MF_URL: 'https://www.mojomf.com/',
  MOJO_IMG_URL: 'https://marketsmojostatic.motilaloswal.com/',
  INFINITY_FRAPI_URL: 'https://frapi.mojoinfinity.com/',
  API_URL: 'https://marketsmojoapi.motilaloswal.com/apiv1/',
  ISCLMM: false,
  CLMM_NAME:'',
  IS_INTER: false
};
if (window.location.host == "marketsmojo.motilaloswal.com") {
  environment.FRAPI_URL = 'https://marketsmojoapi.motilaloswal.com/';
  environment.MOJO_URL = 'https://marketsmojo.motilaloswal.com/';
  environment.MOJO_SITE = 'https://marketsmojo.motilaloswal.com/';
  environment.MOJO_MF_URL = 'https://www.mojomf.com/';
  environment.TRA80_URL = 'https://prepod-frapi.trading80.com/';
  environment.INFINITY_FRAPI_URL = 'https://prepod-frapi.mojoinfinity.com/'
  environment.STOCK_URL = 'https://marketsmojo.motilaloswal.com/stocks-analysis/';
  environment.MOJO_IMG_URL = 'https://marketsmojostatic.motilaloswal.com/images/';
  environment.API_URL = 'https://marketsmojoapi.motilaloswal.com/apiv1/';

} 
